import { useEffect, useState, useCallback, useRef } from "react";
import Link from "next/link";
import Image from "next/image";
import { cookies } from "next/headers";
import {
  Container,
  Row,
  Col,
  Button,
  Form,
  Spinner,
  Modal,
  Tooltip,
  OverlayTrigger,
} from "react-bootstrap";
import { useRouter } from "next/router";
import { useSelector, useDispatch } from "react-redux";
import { toast } from "react-toastify";
import moment from "moment-timezone";
import { formatPhoneNumber } from "react-phone-number-input";
import { maskNumber, maskEmail } from "@/helper/common";
import {
  setBookingAvailableTypes,
  setSelectedAppointment,
  setSelectedBookingType,
  setSelectedDate,
  setDateSliderPayload,
  setSelectedSlot,
} from "@/redux/features/bookAppointmentSlice";
import { healerServices } from "@/services/healerServices";
import Layout from "@/components/layout";
import { customerServices } from "@/services/customerServices";
import { setPaymentData } from "@/redux/features/paymentSlice";
import Head from "next/head";
import soft from "timezone-soft";
import spacetime from "spacetime";

const HealerBookingSlots = (props) => {
  const { push, query } = useRouter();
  const query_id = query.slug.split("-");
  const query_length = query_id.length - 1;
  const dispatch = useDispatch();
  const { session, userData } = useSelector((state) => state.user);
  const [userType, setUserType] = useState(null);

  const {
    availableBookingTypes,
    selectedAppointment,
    selectedBookingType,
    selectedDate,
    dateSliderPayload,
    selectedSlot,
  } = useSelector((state) => state.bookAppointment);
  const [data, setData] = useState(props?.details ?? {});
  const [bookingTypes, setBookingTypes] = useState(props?.bookingTypes ?? []);
  const [appointments, setAppointments] = useState(props.appointments ?? []);
  const [lgShow, setLgShow] = useState(false);
  const [slotDates, setSlotDates] = useState([]);
  const [itemData, setItemData] = useState({});
  const [showBookingTypeData, setshowBookingTypeData] = useState("");
  const [bookingTypeName, setBookingTypeName] = useState("");
  const [activeTab, setActiveTab] = useState(0);
  const [slots, setSlots] = useState([]);
  const [timezoneShow, setTimezoneShow] = useState({});
  const [datesIndex, setDatesIndex] = useState(1);
  const [showSpinner, setShowSpinner] = useState(false);
  const [disabledBtn, setDisabledBtn] = useState(false);
  const [disabledPrevBtn, setDisabledPrevBtn] = useState(true);
  const [timeSlots, setTimeSlots] = useState();
  const now = spacetime.now(moment.tz.guess(true));
  const tz = now.timezone();
  const min = tz.current.offset * 60;
  const hr = `${(min / 60) ^ 0}:${min % 60 === 0 ? "00" : Math.abs(min % 60)}`;
  const prefix = `(${"GMT"}${hr.includes("-") ? hr : `+${hr}`})`;
  const tzStrings = soft(moment.tz.guess(true));
  const altrr_timezone = tzStrings[0]?.long.split("(");
  const gmt_timezone = altrr_timezone[1]?.slice(10);
  const [healerSlotsMeta, setHealerSlotsMeta] = useState(
    props?.healerSlotsMeta ?? {}
  );
  const [showSideButton, setShowSideButton] = useState(false);
  const firstSectionRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      if (!firstSectionRef.current) return;

      const sectionTop = firstSectionRef.current.getBoundingClientRect().bottom;

      setShowSideButton(sectionTop < 0);
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleAppointmentClick = useCallback(
    async (item) => {
      if (appointments.length && bookingTypes.length) {
        dispatch(
          setSelectedAppointment({
            ...item?.appointment,
            is_free: item?.is_free,
            total_price: item?.total_price,
          })
        );
        const bookingTypeIds = item?.booking_types?.map((i) => i.id);
        const items = bookingTypes.filter((i) => {
          //if id 3 then pass 1,2
          if (bookingTypeIds?.includes(3) && i.id != 3) {
            return i;
          } else if (bookingTypeIds?.includes(i.id) && i.id != 3) {
            return i;
          }
        });
        //
        dispatch(setBookingAvailableTypes(items));
      }
    },
    [appointments, bookingTypes, dispatch]
  );

  useEffect(() => {
    if (Object.keys(data).length == 0) {
      push("/404");
    }
    const now = spacetime.now(moment.tz.guess(true));
    const tz = now.timezone();
    const min = tz.current.offset * 60;
    const hr = `${(min / 60) ^ 0}:${
      min % 60 === 0 ? "00" : Math.abs(min % 60)
    }`;
    setTimezoneShow({
      prefix: `(${"GMT"}${hr.includes("-") ? hr : `+${hr}`})`,
      tzStrings: soft(moment.tz.guess(true))[0],
    });
    handleAppointmentClick(appointments[0]);
  }, []);

  useEffect(() => {
    const handleBookingTypeClick = (item) => {
      dispatch(setSelectedBookingType(item));
      setBookingTypeName(item[0]?.name);
    };

    if (availableBookingTypes.length == 1) {
      handleBookingTypeClick(availableBookingTypes);
    } else {
      handleBookingTypeClick(availableBookingTypes);
    }
  }, [availableBookingTypes, dispatch]);

  useEffect(() => {
    if (userData?.roles?.length) {
      if (userData.roles[0].name == "Healer") {
        setUserType("Healer");
      } else {
        setUserType("Customer");
      }
    }
  }, [userData]);

  const fetchHealerAvailableDates = async (payload) => {
    setShowSpinner(true);
    const res = await healerServices.getHealerAvailableDates({
      id: payload.id,
      session_id: payload.session_id,
      page: payload.page,
      customer_timezone: moment.tz.guess(true),
    });
    if (res.status) {
      setSlotDates(res.data);
      setShowSpinner(false);
    } else {
      setShowSpinner(false);
      setDisabledBtn(true);
      toast.error(res.message, {
        autoClose: 5000,
      });
    }
  };

  const handleDateSelection = useCallback(
    async (item) => {
      const fetchHealerAvailableSlots = async (payload) => {
        const res = await healerServices.getHealerAvailableSlots({
          id: payload.id,
          healer_id: payload.healer_id,
          date: payload.date,
          customer_timezone: moment.tz.guess(true),
        });
        if (res) {
          setSlots(res.data.slots);
          dispatch(setPaymentData([]));
        } else {
          toast.error(res.message, {
            autoClose: 5000,
          });
        }
      };

      if (
        slotDates.length &&
        query_id[query_length] &&
        selectedAppointment?.session_id
      ) {
        const payload = {
          id: selectedAppointment.session_id,
          healer_id: query_id[query_length],
          date: item.date,
        };
        fetchHealerAvailableSlots(payload);
        dispatch(setSelectedDate(item));
      }
    },
    [query, selectedAppointment, slotDates, dispatch]
  );

  const dateNavigation = (side) => {
    let index;
    if (side == "next") {
      index = datesIndex + 1;
      setDisabledPrevBtn(false);
    } else {
      index = datesIndex - 1;
      setDisabledBtn(false);
      if (index <= 1) {
        setDisabledPrevBtn(true);
      }
    }

    //if index goes less than to 1 then reset it to 1
    if (index < 1) {
      index = 1;
    }
    setDatesIndex(index);
    fetchHealerAvailableDates({ ...dateSliderPayload, page: index });
  };

  useEffect(() => {
    if (selectedAppointment?.id && query_id[query_length]) {
      const payload = {
        id: query_id[query_length],
        session_id: selectedAppointment.session_id,
        page: 1,
      };
      dispatch(setDateSliderPayload(payload));
      fetchHealerAvailableDates(payload);
    }
  }, [query, selectedAppointment, dispatch]);

  const handleSlotClick = (item) => {
    dispatch(setSelectedSlot(item));
  };

  const proceedBooking = async () => {
    const time = selectedSlot?.time?.split("-");
    const payload = {
      booked_by: session ? session?.id : cookies().get("guest-user-id"),
      appointment_id: selectedAppointment?.id,
      session_id: selectedAppointment?.session_id,
      time: moment(
        selectedDate?.date + " " + time[0],
        "YYYY-MM-DD hh:mm A"
      ).format("YYYY-MM-DD HH:mm:ss"),
      interval: data?.healer?.healer_interval?.timing ?? 0,
      healer_id: data?.healer?.id,
      customer_timezone: moment.tz.guess(true),
    };

    const res = await customerServices.slotBooking(payload);
    if (res.status) {
      if (typeof window !== "undefined") {
        const courseBooking = JSON.parse(
          sessionStorage.getItem("courseBooking")
        );
        if (courseBooking && Object.keys(courseBooking).length) {
          sessionStorage.removeItem("courseBooking");
        }
        sessionStorage.setItem(
          "appointmentBooking",
          JSON.stringify({
            selectedAppointment: {
              ...selectedAppointment,
              slug: query?.slug,
            },
            selectedBookingType,
            selectedDate,
            selectedSlot,
            bookedSlotId: res?.data?.id,
            healer_tz: data?.healer?.time_zone,
          })
        );

        sessionStorage.setItem("returnFlag", JSON.stringify(true));
      }

      if (session && session?.id) {
        if (selectedAppointment?.is_free) {
          push({
            pathname: "/free-thank-you",
            query: {
              type: "appointment",
              id: res?.data?.id,
              healer_tz: data?.healer?.time_zone,
            },
          });
        } else {
          push({
            pathname: "/payment",
            query: { type: "appointment", id: res?.data?.id },
          });
        }
      } else {
        push("/auth/customer/social/signin");
      }
    } else {
      toast.error(res?.message, {
        autoClose: 5000,
      });
    }
  };

  return (
    <>
      {data?.healer?.id ? (
        <>
          <Head>
            <title>{healerSlotsMeta?.meta_title}</title>
            <meta name="title" content={healerSlotsMeta?.meta_title}></meta>
            <meta
              name="description"
              content={healerSlotsMeta?.meta_description}
            ></meta>
            <meta
              name="keywords"
              content={healerSlotsMeta?.meta_keywords}
            ></meta>
            <meta property="og:type" content="website"></meta>
            <meta
              property="og:title"
              content={healerSlotsMeta?.meta_title}
            ></meta>
            <link
              rel="canonical"
              href={`https://www.zenkify.com/healers/${query.slug}/slots`}
            ></link>
            {/* <meta
              property="og:image"
              content={healerSlotsMeta?.meta?.og_image}
            ></meta> */}
          </Head>

          <section className="detailspay-section">
            <Container>
              <Row>
                <Col lg={9}>
                  <div className="header-card mb-5" ref={firstSectionRef}>
                    <Row>
                      <Col md={12}>
                        <div className="inner-box">
                          <div className="healer-image">
                            <Image
                              height={150}
                              width={150}
                              src={
                                data?.healer?.image === null
                                  ? "/images/dummy-user.svg"
                                  : data?.healer?.image
                              }
                              alt=""
                            />
                          </div>
                          <div className="details-healer">
                            <div className="leftside-healerdetails">
                              <div className="name">
                                <Link
                                  href={`/healers/${data?.healer?.slug}/detail`}
                                >
                                  <h4>
                                    {data?.healer?.first_name &&
                                    data?.healer?.last_name
                                      ? `${data?.healer?.first_name} ${data?.healer?.last_name}`
                                      : "Not Specified"}
                                  </h4>
                                </Link>
                                <i className="ri-checkbox-circle-fill"></i>
                              </div>
                              <h6>
                                {data?.healer?.detail?.profile_tag ??
                                  "Not Specified"}
                              </h6>
                            </div>
                            <div className="feedback">
                              <span>
                                {[...Array(5).keys()].map((i, j) => (
                                  <>
                                    <i
                                      key={j}
                                      className={`ri-star-fill ${
                                        i + 1 <= data?.rating ? "star-fill" : ""
                                      }`}
                                    ></i>
                                  </>
                                ))}
                              </span>
                              <p>{`${data?.feedback} Feedback`}</p>
                            </div>
                            <div className="bottom-healer-details">
                              {/* <ul className="list-details">
                                <li>
                                  <i className="ri-phone-line"></i>{" "}
                                  {session?.id ? (
                                    data?.healer?.mobile_number ? (
                                      <Link
                                        href={
                                          `tel:${
                                            data?.healer?.country_code +
                                            data?.healer?.mobile_number
                                          }` ?? "Not Specified"
                                        }
                                      >
                                        {data?.healer?.country_code +
                                          " " +
                                          formatPhoneNumber(
                                            data?.healer?.country_code +
                                              data?.healer?.mobile_number
                                          ) ?? "Not Specified"}
                                      </Link>
                                    ) : (
                                      "Not Specified"
                                    )
                                  ) : (
                                    <Link
                                      href="/auth/customer/social/signin"
                                      title="Sign In To View Mobile Number"
                                    >
                                      {data?.healer?.mobile_number
                                        ? maskNumber(
                                            data?.healer?.mobile_number
                                          )
                                        : "Not Specified"}
                                    </Link>
                                  )}
                                </li>
                                <li>
                                  <i className="ri-mail-line"></i>{" "}
                                  {session?.id ? (
                                    <Link
                                      href={`mailto:${
                                        data?.healer?.email ?? "Not Specified"
                                      }`}
                                    >
                                      {data?.healer?.email ?? "Not Specified"}
                                    </Link>
                                  ) : (
                                    <Link
                                      href="/auth/customer/social/signin"
                                      title="Sign In To View Email Address"
                                    >
                                      {data?.healer?.email
                                        ? maskEmail(data?.healer?.email)
                                        : "Not Specified"}
                                    </Link>
                                  )}
                                </li>
                              </ul> */}
                              <ul className="list-details">
                                <li>
                                  <i className="ri-calendar-line"></i>{" "}
                                  {data?.healer?.detail?.experience
                                    ? data?.healer?.detail?.experience > 1
                                      ? data?.healer?.detail?.experience +
                                        " Years"
                                      : data?.healer?.detail?.experience +
                                        " Year"
                                    : "0 Year"}{" "}
                                  Experience
                                </li>
                                <li>
                                  <i className="ri-map-pin-line"></i>{" "}
                                  {data?.healer?.state?.name &&
                                  data?.healer?.country?.name
                                    ? `${data?.healer?.state?.name}, ${data?.healer?.country?.name}`
                                    : "Not Specified"}{" "}
                                  <Link
                                    href={`${data?.healer?.detail?.google_map_url}`}
                                    target="_blank"
                                    className="getdirection"
                                  >
                                    {" "}
                                    {data?.healer?.detail?.google_map_url
                                      ? "- Get Directions"
                                      : ""}
                                  </Link>
                                </li>
                                {data?.free_call == 1 ? (
                                  <li>
                                    <i className="ri-customer-service-line"></i>{" "}
                                    Free & Paid Call Available
                                  </li>
                                ) : (
                                  <li>
                                    <i className="ri-customer-service-line"></i>{" "}
                                    Paid Call Available
                                  </li>
                                )}
                              </ul>
                            </div>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                  <div className="timeslot-section">
                    <div className="title">
                      <h1>Select a slot</h1>
                    </div>

                    <div className="slot-form mb-3">
                      <Form>
                        <Form.Label className="form-label mb-3">
                          Select Service Type
                        </Form.Label>
                        <Row>
                          <Col md={12}>
                            <div className="select-service-type">
                              <ul className="nav nav-tabs">
                                {appointments?.map((item, index) => {
                                  return (
                                    <>
                                      <li>
                                        <a
                                          data-toggle="tab"
                                          href="javascript:void(0)"
                                          className={
                                            activeTab == index
                                              ? "active show"
                                              : ""
                                          }
                                          style={
                                            item?.is_free == 1
                                              ? { borderColor: "red" }
                                              : {}
                                          }
                                          onClick={(e) => {
                                            dispatch(setSelectedSlot({}));
                                            dispatch(setSelectedDate({}));
                                            setSlots([]);
                                            handleAppointmentClick(item);
                                            setActiveTab(index);
                                            setTimeSlots(item);
                                            setItemData(item);
                                            setshowBookingTypeData(
                                              item?.booking_types[0]?.name
                                            );
                                          }}
                                        >
                                          <h5>
                                            {item?.is_free == 1
                                              ? `${item?.appointment?.name}(Free)`
                                              : item?.is_free == 0
                                              ? item?.appointment?.name
                                              : "Not Specified"}
                                          </h5>
                                          <div className="select-service-time">
                                            <h6>
                                              {item?.appointment?.duration
                                                ? `${item?.appointment?.duration} Min.`
                                                : "Not Specified"}
                                              @
                                              <strong>
                                                {`$${item?.total_price}` ??
                                                  "Not Specified"}
                                              </strong>{" "}
                                            </h6>
                                            <span>
                                              {item?.booking_types[0]?.name
                                                ? `(${
                                                    item?.booking_types[0]
                                                      ?.name == "Both"
                                                      ? "In-Person & Online"
                                                      : item?.booking_types[0]
                                                          ?.name
                                                  })`
                                                : "Not Specified"}
                                            </span>
                                          </div>
                                          <p>
                                            {item?.appointment?.description
                                              ? `${item?.appointment?.description?.slice(
                                                  0,
                                                  100
                                                )}`
                                              : "Not Specified"}{" "}
                                            <span
                                              className="slots-viewmore"
                                              onClick={() => {
                                                setLgShow(true);
                                              }}
                                            >
                                              {item?.appointment?.description
                                                ?.length > 100
                                                ? "....View More"
                                                : ""}{" "}
                                            </span>
                                          </p>
                                        </a>
                                      </li>
                                    </>
                                  );
                                })}
                              </ul>
                            </div>
                          </Col>
                        </Row>
                      </Form>
                    </div>
                    <div className="select-slot">
                      <div className="sub-heading mb-3">
                        <h6>
                          Select Slot date & Time{" "}
                          <span style={{ color: "red", "font-weight": "bold" }}>
                            {` ${timezoneShow?.prefix} ${timezoneShow?.tzStrings?.standard.name}`}
                          </span>
                        </h6>
                      </div>
                      <div className="innerbox-slot">
                        {showSpinner ? (
                          <div className="text-center mb-3">
                            <Spinner animation="border" role="status">
                              <span className="visually-hidden">
                                Loading...
                              </span>
                            </Spinner>
                          </div>
                        ) : (
                          <div className="timeslot-tabing">
                            <div
                              className="nav nav-tabs"
                              id="myTab"
                              role="tablist"
                            >
                              {slotDates.length
                                ? slotDates?.map((item, index) => {
                                    return (
                                      <div
                                        className="nav-item"
                                        role="presentation"
                                        key={index}
                                      >
                                        <Button
                                          className={
                                            "nav-link " +
                                            (item.date == selectedDate?.date
                                              ? "active"
                                              : "")
                                          }
                                          data-bs-toggle="tab"
                                          data-bs-target={`#timeslot-${index}`}
                                          role="tab"
                                          aria-controls={`timeslot-${index}`}
                                          aria-selected="true"
                                          name="available_date"
                                          value={item?.title}
                                          disabled={
                                            item?.is_closed == 1 ||
                                            item?.holiday == 1
                                              ? true
                                              : item?.slotAvailable == 0
                                              ? true
                                              : ""
                                          }
                                          onClick={() => {
                                            dispatch(setSelectedSlot({}));
                                            handleDateSelection(item);
                                          }}
                                        >
                                          <h4>{item?.title}</h4>
                                          <p>
                                            {item?.is_closed == 1
                                              ? "Closed"
                                              : item?.holiday == 1
                                              ? "Holiday"
                                              : item?.slotAvailable > 0
                                              ? `${item?.slotAvailable} Slots Available`
                                              : "No Slots Available"}
                                          </p>
                                        </Button>
                                      </div>
                                    );
                                  })
                                : ""}
                            </div>
                          </div>
                        )}

                        <div className="slot-nav">
                          <Button
                            className="navbtn btn-left"
                            disabled={disabledPrevBtn}
                            onClick={() => dateNavigation("prev")}
                          >
                            <i className="ri-arrow-left-s-line"></i>
                          </Button>
                          <Button
                            className="navbtn btn-right"
                            disabled={disabledBtn}
                            onClick={() => dateNavigation("next")}
                          >
                            <i className="ri-arrow-right-s-line"></i>
                          </Button>
                        </div>
                      </div>
                      <div
                        className="tab-content timeslot-content"
                        id="myTabContent"
                      >
                        {slotDates.length
                          ? slotDates?.map((item, index) => (
                              <>
                                <div
                                  className={
                                    "tab-pane fade " +
                                    (item?.date == selectedDate?.date
                                      ? "show active"
                                      : "")
                                  }
                                  id={`timeslot-${index}`}
                                >
                                  <ul>
                                    {item?.date == selectedDate?.date &&
                                    slots?.length ? (
                                      slots?.map((item, index) => (
                                        <>
                                          <li>
                                            <Button
                                              className={
                                                "timebtn " +
                                                (item?.time ==
                                                selectedSlot?.time
                                                  ? "active"
                                                  : "")
                                              }
                                              onClick={(e) =>
                                                handleSlotClick(item)
                                              }
                                              disabled={
                                                item.booked == 1 ||
                                                item.status == 0
                                                  ? true
                                                  : ""
                                              }
                                            >
                                              {item.time}
                                            </Button>
                                          </li>
                                        </>
                                      ))
                                    ) : (
                                      <div className="text-center mb-5 m-auto">
                                        <Spinner
                                          animation="border"
                                          role="status"
                                        >
                                          <span className="visually-hidden">
                                            Loading...
                                          </span>
                                        </Spinner>
                                      </div>
                                    )}
                                  </ul>
                                </div>
                              </>
                            ))
                          : ""}
                      </div>
                    </div>
                  </div>
                </Col>
                <Col lg={3}>
                  <div className="sticky-card">
                    <div className="heading">
                      <h4>Booking Details</h4>
                    </div>
                    <div className="list-booking">
                      <ul>
                        <li>
                          <span>
                            <i className="ri-clipboard-line"></i>
                            Service Type
                          </span>
                          <span>{selectedAppointment?.name}</span>
                        </li>
                        <li>
                          <span>
                            <i className="ri-file-text-line"></i>
                            Booking Type
                          </span>
                          <span>
                            {selectedBookingType?.length == 2
                              ? "In-Person & OnLine"
                              : bookingTypeName}
                          </span>
                        </li>
                        <li>
                          <span>
                            <i className="ri-calendar-line"></i>
                            Selected Date
                          </span>
                          <span>
                            {selectedDate?.date && selectedSlot?.time
                              ? moment(selectedDate?.date)
                                  .tz(moment.tz.guess(true))
                                  .format("ddd DD MMM YYYY")
                              : "N/A"}
                            {selectedDate?.date && selectedSlot?.time ? (
                              <OverlayTrigger
                                delay={{
                                  hide: 450,
                                  show: 300,
                                }}
                                overlay={(props) => (
                                  <Tooltip {...props}>
                                    {`(${tzStrings[0].standard.name})`}
                                  </Tooltip>
                                )}
                                placement="top"
                              >
                                <span
                                  style={{ cursor: "pointer" }}
                                >{` (${tzStrings[0].standard.abbr})`}</span>
                              </OverlayTrigger>
                            ) : (
                              ""
                            )}
                          </span>
                        </li>
                        <li>
                          <span>
                            <i className="ri-time-line"></i>
                            Selected Time
                          </span>
                          <span>
                            {selectedDate?.date && selectedSlot?.time
                              ? selectedSlot?.time
                              : "N/A"}
                          </span>
                        </li>
                      </ul>
                    </div>
                    <div className="footer-box">
                      <div className="amount-box">
                        <h6>Total Amount</h6>
                        <span>${selectedAppointment?.total_price}</span>
                      </div>
                      <Button
                        onClick={() => proceedBooking()}
                        disabled={
                          !(
                            selectedSlot &&
                            selectedSlot.time &&
                            selectedDate &&
                            userType != "Healer"
                          )
                        }
                        className="theme-btn"
                      >
                        Proceed to Pay
                      </Button>
                    </div>
                  </div>
                </Col>
                <Modal
                  animation
                  className="popup-slots review-modal"
                  id="booking-veiwdetails"
                  show={lgShow}
                  onHide={() => setLgShow(false)}
                  size="md"
                  centered
                >
                  <Modal.Body>
                    <div>
                      <h3>{itemData?.appointment?.name}</h3>
                      <div className="person-details">
                        <h6>
                          {`${itemData?.appointment?.duration} Min.   `}
                          <strong>{`$${itemData?.total_price}`}</strong>{" "}
                        </h6>
                        <span>{`(${showBookingTypeData})`}</span>
                      </div>
                      <p>{itemData?.appointment?.description ?? "No Review"}</p>
                    </div>
                  </Modal.Body>
                  <Modal.Footer>
                    <button
                      type="button"
                      className="theme-btn"
                      data-bs-dismiss="modal"
                      onClick={() => setLgShow(false)}
                    >
                      Close
                    </button>
                  </Modal.Footer>
                </Modal>
              </Row>
            </Container>
          </section>
          <Link
            id="floatingBook"
            className="floating-book"
            aria-label="Book a FREE call now"
            href="/healers"
            style={{ opacity: showSideButton ? 1 : 0 }}
          >
            Book a FREE call now
          </Link>
        </>
      ) : (
        <h3 className="text-center">No records found!</h3>
      )}
    </>
  );
};

export default HealerBookingSlots;

HealerBookingSlots.getLayout = function getLayout(page) {
  return <Layout>{page}</Layout>;
};

// ssr
export async function getServerSideProps(context) {
  const { query } = context;
  const query_id = query.slug.split("-");
  const query_length = query_id.length - 1;
  const fetchHealerData = async () => {
    const res = await healerServices.getHealerDetails({
      slug: query.slug,
      timezone: moment.tz.guess(true),
    });
    if (res.status) {
      return res.data;
    } else {
      toast.error(res.message, {
        autoClose: 5000,
      });
    }
  };

  const fetchAppointments = async () => {
    const res = await healerServices.getHealerAppointments(
      query_id[query_length]
    );
    if (res.status) {
      return res.data;
    } else {
      toast.error(res.message, {
        autoClose: 5000,
      });
    }
  };

  const fetchBookingTypes = async () => {
    const res = await healerServices.getBookingTypes();
    if (res.status) {
      return res.data;
    } else {
      toast.error(res.message, {
        autoClose: 5000,
      });
    }
  };

  const fetchHealerSlotsMeta = async () => {
    try {
      const res = await healerServices.getHealerSlotsMetaData(
        query_id[query_length]
      );
      if (res.status) {
        return res.data;
      }
    } catch (error) {
      console.error("Error fetching slider data:", error);
    }
  };

  const details = (await fetchHealerData()) ?? {};
  const appointments = (await fetchAppointments()) ?? {};
  const bookingTypes = (await fetchBookingTypes()) ?? {};
  const healerSlotsMeta = (await fetchHealerSlotsMeta()) ?? {};

  // Pass data to the page via props
  return { props: { details, appointments, bookingTypes, healerSlotsMeta } };
}
